module.exports = __webpack_public_path__ + "img/body-2.4c6c3f6d.png";